




































import { Vue, Prop, Emit, Component, Watch } from "vue-property-decorator";
import ListSearchAndSelect from "@/components/common/List/ListSearchAndSelect.vue";

@Component({
  components: {
    ListSearchAndSelect,
  },
})
export default class OutletFilter extends Vue {
  @Prop() readonly outletList!: Array<any>;

  private listingList: Array<any> = this.outletList;
  private searchedList: Array<any> = this.listingList;
  private searchText: string='';

  private selectedList: Array<any> = [];
  
  @Watch('outletList')
  changeInitValues()
  {
      this.listingList = this.outletList;
      this.searchedList = this.listingList;
      this.selectedList = [];
      this.searchText = '';
  }

  @Watch('selectedList')
  emitSelectedOutlet(){
      this.$emit('SelectedOutlets', this.selectedList);
  }

  private selectOutlet(itemSelected: any) {
    // Add in Seleted List
    this.selectedList.push(itemSelected);
    // Remove from Listing
    this.listingList = this.listingList.filter(function (ele) {
      return ele.id != itemSelected.id;
    });
    this.SearchTextChanged(this.searchText);
  }

  private SearchTextChanged(newVal: string){
      if(newVal==null || newVal==undefined)
      {
          newVal='';
      }
      this.searchText = newVal;
      this.searchedList = this.listingList.filter(item => {
          if(item.shopName.toUpperCase().includes(newVal.toUpperCase()))
          {
              return item;
          }
      });
  }

  private removeSelectedOutlet(itemSelected:any)
  {
      // Add in Listing
    this.listingList.push(itemSelected);
    // Remove from selection List
    this.selectedList = this.selectedList.filter(function (ele) {
      return ele.id != itemSelected.id;
    });
    this.SearchTextChanged(this.searchText);
  }

  private selectAll(){
      this.listingList.forEach(item=> this.selectedList.push(item));
      this.listingList = [];
      this.SearchTextChanged(this.searchText);
  }
}
